export const hasSellerAddressInfo = inventory =>
  !!(inventory?.sellerInfo?.address?.city && inventory?.sellerInfo?.address?.stateCode);
